if (!customElements.get('product-details-tabs')) {
  customElements.define('product-details-tabs', class extends HTMLElement {
    connectedCallback() {
      this.reviewTimedOut = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.querySelector('[role="tablist"]').hidden = false;
      this.setAttribute('data-enhanced', '');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab), options);
        tab.addEventListener('keydown', (event) => {
          const keys = { ArrowRight: (index + 1) % 3, ArrowLeft: (index + 2) % 3, Home: 0, End: 2 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = this.tabs[keys[event.key]];
          this.select(next.dataset.tab);
          next.focus();
        }, options);
      });
      this.select('description');
      this.onHash = () => {
        if (/^#(judgeme_product_reviews|shopify-product-reviews|reviews)$/.test(location.hash)) this.openReviews();
      };
      window.addEventListener('hashchange', this.onHash, options);
      document.addEventListener('click', (event) => {
        const badge = event.target.closest('.jdgm-preview-badge');
        const link = event.target.closest('a');
        const url = link ? new URL(link.href, location.href) : null;
        if (badge || (url && url.pathname === location.pathname && /^#(judgeme_product_reviews|shopify-product-reviews|reviews)$/.test(url.hash))) {
          if (event.target.closest('[data-review-retry]')) return;
          event.preventDefault();
          this.openReviews();
        }
      }, options);
      this.addEventListener('shopify:block:select', () => this.select('reviews'), options);
      this.querySelector('[data-review-retry]')?.addEventListener('click', (event) => {
        event.preventDefault();
        history.replaceState(null, '', '#judgeme_product_reviews');
        location.reload();
      }, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const main = document.querySelector('product-info[id^="MainProduct"]');
          if (main?.dataset.productId !== this.dataset.productId || main?.dataset.section !== data.sectionId) return;
          const sku = data.variant?.sku || '';
          this.querySelector('[data-spec-sku]').textContent = sku;
          this.querySelector('[data-spec-sku-row]').hidden = !sku.trim();
        });
      }
      this.observer = new MutationObserver(() => this.checkReviews());
      const reviewWidget = this.querySelector('[data-review-widget]');
      if (reviewWidget) this.observer.observe(reviewWidget, { childList: true, subtree: true, attributes: true });
      this.onHash();
    }

    select(name) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.panel !== name; });
      if (name === 'reviews' && !this.reviewTimer) {
        this.checkReviews();
        this.reviewTimer = setTimeout(() => {
          this.reviewTimedOut = true;
          this.checkReviews();
        }, 15000);
      }
    }

    openReviews() {
      this.select('reviews');
      this.tabs.find((tab) => tab.dataset.tab === 'reviews').focus({ preventScroll: true });
      this.querySelector('[role="tablist"]').scrollIntoView({ block: 'start' });
    }

    checkReviews() {
      const widget = this.querySelector('.jdgm-review-widget');
      const rendered = widget?.innerText.trim() || widget?.querySelector('.jdgm-rev-widg, .jdgm-rev-widg__body, [data-number-of-reviews]');
      const status = this.querySelector('[data-review-status]');
      if (!status) return;
      status.hidden = Boolean(rendered) || !this.reviewTimedOut;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.unsubscribe?.();
      clearTimeout(this.reviewTimer);
      this.reviewTimer = null;
    }
  });
}
